export const mediumWidth = 768;
export const largeWidth = 992;
